export default __webpack_public_path__ + "static/media/2.cdc9dea8.jpeg";